export const MODAL_LIVE_REGION_CLASS = 'tn-modal-live-region';
